import { call, put, takeLatest } from 'redux-saga/effects';
import TYPES from './_actionTypes';
import {
  uploadStudentsSuccess,
  uploadStudentsFailure,
  fetchJobStatusSuccess,
  fetchJobStatusFailure,
} from './_actions';
import StudentBulkUploadHelper from '../../../../utils/API/BackendHelper/admin/studentBulkUpload';

function* uploadStudentsSaga(action) {
  try {
    const { file, collegeId, batch, semester } = action.payload;
    const response = yield call(StudentBulkUploadHelper.uploadStudents, {
      file,
      collegeId,
      batch,
      semester,
    });

    if (response.success) {
      // 202 returns { jobId, totalRecords }. Normalize to the poll-status shape
      // so the watcher can render progress immediately, before the first poll.
      const normalized = {
        id: response.data.jobId,
        total_records: response.data.totalRecords ?? 0,
        processed_records: 0,
        failed_records: 0,
        already_existing: 0,
        result_json: [],
        status: 'pending',
        created_at: new Date().toISOString(),
        filename: file?.name || null,
      };
      yield put(uploadStudentsSuccess(normalized));
    } else {
      yield put(uploadStudentsFailure(response.message || 'Upload failed'));
    }
  } catch (error) {
    yield put(uploadStudentsFailure(error.message || 'Upload failed'));
  }
}

function* fetchJobStatusSaga(action) {
  try {
    const response = yield call(StudentBulkUploadHelper.getJobStatus, action.payload.jobId);
    if (response.success) {
      yield put(fetchJobStatusSuccess(response.data));
    } else {
      yield put(fetchJobStatusFailure(response.message || 'Failed to fetch job status', response.status));
    }
  } catch (error) {
    yield put(fetchJobStatusFailure(error.message || 'Failed to fetch job status'));
  }
}

export default function* studentBulkUploadSaga() {
  yield takeLatest(TYPES.UPLOAD_REQUEST, uploadStudentsSaga);
  yield takeLatest(TYPES.FETCH_JOB_STATUS_REQUEST, fetchJobStatusSaga);
}
